import React, { useEffect } from 'react';
import { createPopper } from '@popperjs/core';
import PropTypes from 'prop-types';
import { InfoCircleFilledIcon } from '@trp-beacon-ui-kit/style-icons';

import defaultStyles from './styles.css';

const ToolTip = ({
  callerNode,
  id,
  description,
  maxNoteWidth,
  popOutPlacement,
  userStyles
}) => {
  let clickObj;
  let popperInstance = null;
  let reference = null;
  let popper = null;
  const eventListeners = ['resize', 'click', 'keyup', 'keydown', 'touchstart'];
  useEffect(() => {
    reference = document.getElementById(id);
    popper = document.getElementById(`popper-${id}`);
  });

  function destroy() {
    popperInstance.destroy();
    popperInstance = null;
    popper.setAttribute('show-popper', false);
  }

  function hideTooltip() {
    teardownHideTipHandlers(); // eslint-disable-line no-use-before-define
    destroy();
  }

  function teardownHideTipHandlers() {
    for (let i = 0; i < eventListeners.length; i++) {
      window.removeEventListener(eventListeners[i], hideTooltip, true);
    }
  }

  function setupHideTipHandlers() {
    for (let i = 0; i < eventListeners.length; i++) {
      window.addEventListener(eventListeners[i], hideTooltip, true);
    }
  }

  function createToolTipPopper() {
    if (popper && reference) {
      setupHideTipHandlers();
      popper.setAttribute('show-popper', true);
      popperInstance = createPopper(reference, popper, {
        placement: popOutPlacement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 4]
            }
          }
        ]
      });
    }
  }

  if (callerNode) {
    clickObj = (
      <>
        <span className="trp-info">{callerNode}</span>
        <style jsx>{defaultStyles}</style>
        <style jsx>{userStyles}</style>
      </>
    );
  } else {
    clickObj = (
      <>
        <img
          alt="Tooltip"
          className="trp-info-circle"
          src={InfoCircleFilledIcon}
        />
        <style jsx>{defaultStyles}</style>
        <style jsx>{userStyles}</style>
      </>
    );
  }
  return (
    <>
      <button
        type="button"
        id={id}
        className="trp-tooltip"
        onClick={createToolTipPopper}>
        {clickObj}
      </button>
      <div
        style={{ maxWidth: `${maxNoteWidth}` }}
        id={`popper-${id}`}
        className="popper"
        show-popper={false}>
        {description}
        <div id="arrow" className="arrow" data-popper-arrow />
      </div>
      <style jsx>{defaultStyles}</style>
      <style jsx>{userStyles}</style>
    </>
  );
};

ToolTip.defaultProps = {
  callerNode: null,
  maxNoteWidth: '200px',
  popOutPlacement: 'right',
  userStyles: defaultStyles
};

ToolTip.propTypes = {
  callerNode: PropTypes.node,
  id: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  maxNoteWidth: PropTypes.string,
  popOutPlacement: PropTypes.node,
  userStyles: PropTypes.string
};

export default ToolTip;
